import { useFormContext } from '../context/FormContext';

export function StepIndicatorSimple() {
  const { form, formService, scrollService, stateService, forceUpdate } = useFormContext();

  const setActiveStep = (stepId: string) => {
    const step = form.steps.find((s) => s.id === stepId);
    if (!step) {
      return;
    }

    const targetStepIndex = formService.getStepIndex(step);
    const activeStep = formService.getActiveStep();
    const activeStepIndex = activeStep ? formService.getStepIndex(activeStep) : 0;

    if (targetStepIndex < activeStepIndex) {
      stateService.showErrors = false;
      formService.setActiveStep(step);
      scrollService.stepScrollToTop();
      forceUpdate();
    }
  };

  return (
    <div className="stepform-step-indicator">
      <div>Progress:</div>
      <ul>
        {form.steps.map((step) => (
          <li key={step.id}>
            <button
              type="button"
              disabled={formService.isActiveStep(step)}
              onClick={() => setActiveStep(step.id)}
              className="as-text as-link"
            >
              {step.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
